import PropTypes from 'prop-types';
import { Box, Button, Card, Chip, Typography } from '@mui/material';
import { useAuth } from '../../../hooks/use-auth';

export const OverviewBanner = (props) => {
  const { onDismiss, ...other } = props;

  const { user } = useAuth();

  const messages = {
    agente: {
      title: 'Estimado <<name>> ¡Eres el motor de ELAM!',
      subtitle: 'Hemos habilitado esta herramienta tecnológica para ayudarte en la gestión de tus ventas. Aquí podrás administrar y respaldar desde los datos de contacto, hasta los comprobantes de pago de tus clientes. Sin olvidar nada en medio. ¡Agiliza tu operación del día a día con el CRM de ELAM!',
    },
    distribuidora: {
      title: '¡Bienvenido, gerente de distribuidora <<name>>!',
      subtitle: 'Aquí encontrarás todos los contactos, oportunidades y datos de tu distribuidora. Podrás visualizar la situación general así como el desempeño de cada vendedor. ¡Agiliza tu operación del día a día con el CRM de ELAM!',
    },
    administrador: {
      title: '¡Bienvenido, administrador <<name>>!',
      subtitle: 'Aquí encontrarás todos los contactos, oportunidades y datos de todas las distribuidoras. Podrás visualizar la situación general así como el desempeño de cada una de ellas. ¡Agiliza tu operación del día a día con el CRM de ELAM!',
    },
    callcenter: {
      title: '¡Bienvenido, agente de Call Center <<name>>!',
      subtitle: 'Aquí encontrarás toda la información de los clientes que han sido contactados por el Call Center. ¡Agiliza tu operación del día a día con el CRM de ELAM!',
    },
    callcenteradmin: {
      title: '¡Bienvenido, administrador de Call Center <<name>>!',
      subtitle: 'Aquí encontrarás toda la información de los clientes que han sido contactados por el Call Center. ¡Agiliza tu operación del día a día con el CRM de ELAM!',
    },
  }

  return (
    <Card
      sx={{
        alignItems: 'center',
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        display: 'flex',
        flexDirection: {
          xs: 'column',
          md: 'row'
        },
        p: 4
      }}
      {...other}>
      <Box
        sx={{
          mr: 4,
          width: 200,
          height: 200,
          '& img': {
            height: 200,
            width: 'auto'
          }
        }}
      >
        <img
          alt=""
          src="/static/home/conocenos.png"
        />
      </Box>
      <div>
        <Typography
          color="inherit"
          sx={{ mt: 2 }}
          variant="h4"
        >
          {messages[user?.role]?.title.replace('<<name>>', user?.name)}
        </Typography>
        <Typography
          color="inherit"
          sx={{ mt: 1 }}
          variant="subtitle2"
        >
          {messages[user?.role]?.subtitle}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Button
            color="secondary"
            onClick={onDismiss}
            variant="contained"
          >
            Entendido
          </Button>
        </Box>
      </div>
    </Card>
  );
};

OverviewBanner.propTypes = {
  onDismiss: PropTypes.func
};
